import React from 'react';
import { EllipseContainer, Ellipse } from './EllipseAdornment.styled';

interface EllipseAdornmentProps {
  children: React.ReactNode;
  showEllipse?: boolean;
}

/*
 * EllipseAdornment is a component that wraps its children with an ellipse
 * adornment.
 */
const EllipseAdornment = ({ children, showEllipse }: EllipseAdornmentProps) => {
  return (
    <>
      {showEllipse ? (
        <EllipseContainer>
          {children}
          <Ellipse data-cy='ellipse' />
        </EllipseContainer>
      ) : (
        children
      )}
    </>
  );
};

export default EllipseAdornment;
